
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    LazyImg,
    NewSwiper
  }
})
export default class ImageBanner extends Vue {
  @Prop({ default: () => [] }) readonly picList!: string[]
  @Prop({ default: 1016 }) readonly picWidth!: number

  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  activeIndex: number = 0

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  handleChange(index: number) {
    this.activeIndex = index
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
